<template>
  <AppValidationAlert
    v-if="haveInfo"
    :check-valid="status"
    :valid="
      $t(
        'horses:appshow.HorseAccountStatus.Active.label',
        'Active',
        'Label for active horse account status'
      )
    "
    :invalid="
      $t(
        'horses:appshow.HorseAccountStatus.Inactive.label',
        'Inactive',
        'Label for inactive horse account status'
      )
    "
  />
</template>
<script>
import gql from "fraql";
import AppValidationAlert from "@/components/elements/AppValidationAlert.vue";

export default {
  name: "AppShowHorseAccountStatus",
  components: { AppValidationAlert },
  props: {
    horse: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  fragments: {
    horse: gql`
      fragment _ on Horse {
        id
        identifierHeppaStatus
        identifierHeppaDeactivatedAt
        licenceNumberStatus
        licenceNumberDeactivatedAt
      }
    `,
    horseForRegistration: gql`
      fragment _ on HorseForRegistration {
        ueln
        identifierHeppaStatus
        identifierHeppaDeactivatedAt
        licenceNumberStatus
        licenceNumberDeactivatedAt
      }
    `
  },
  computed: {
    status() {
      return (
        this.horse.identifierHeppaStatus == "active" ||
        this.horse.licenceNumberStatus == "active"
      );
    },
    haveInfo() {
      // check if we have enough information to decide the status. If no information then do not show status
      return (
        this.horse.identifierHeppaStatus != null &&
        this.horse.licenceNumberStatus != null
      );
    }
  }
};
</script>
